import { Membership } from "../membership/SDKMembership";
import { Brand } from "./SDKBrand";
import { DesignSystem } from "./SDKDesignSystem";
import { DesignSystemVersion, } from "./SDKDesignSystemVersion";
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - Function Definition
export class BootstrapData {
    // --- --- --- --- --- --- --- --- --- ---
    // MARK: - Constructor
    constructor(model) {
        this.workspaceMembership = model.workspaceMembership
            ? new Membership(model.workspaceMembership)
            : null;
        this.designSystem = model.designSystem
            ? new DesignSystem(model.designSystem)
            : null;
        this.version = model.version ? new DesignSystemVersion(model.version) : null;
        this.brand = model.brand ? new Brand(model.brand) : null;
    }
}
